import React from 'react';
import {RectSkeleton} from 'app/views/components/skeleton';
import styles from './trainingsListItemSkeleton.module.scss';

export const TrainingsListItemSkeleton = () => (
    <div className={styles.skeleton}>
        <div className={styles.thumbnail}>
            <RectSkeleton width={40} height={40} />
        </div>
        <div className={styles.info}>
            <div className={styles.textInfo}>
                <RectSkeleton width={144} />
            </div>
            <div className={styles.textInfo}>
                <RectSkeleton width={81} />
            </div>
            <div className={styles.textInfo}>
                <RectSkeleton width={207} />
            </div>
        </div>
    </div>
);
